import { createColumnHelper } from '@tanstack/react-table';
import { groupBy } from 'lodash';
import { useMemo } from 'react';

import {
    baseCol,
    excludeTradesCol,
    expanderCol,
    moneyCol,
    numberCol,
} from '../../../widgets/Table/columnHelpers/colDef';
import { TradeSideTag } from '../../../widgets/TradeSideTag';
import { CommonTradePlanEntry, getTradeAggregates, getTradeSide, TradeTableProps } from './tradeExecutionUtils';
import { TradesTable } from './TradesTable';

interface TradePlanEntry extends CommonTradePlanEntry {
    side: string;
}

const columnHelper = createColumnHelper<TradePlanEntry>();
export const TradesBySide = ({
    secondaryGrouping,
    filteredTrades,
    excludeTrades,
    viewAsset,
    viewPortfolio,
    viewTrade,
    viewAdvanced,
}: TradeTableProps) => {
    const data: TradePlanEntry[] = useMemo(() => {
        if (!filteredTrades) {
            return [];
        }

        const grouped = groupBy(filteredTrades, getTradeSide);
        return Object.entries(grouped).map(([side, trades]) => {
            return {
                side,
                trades,
                ...getTradeAggregates(trades),
            };
        });
    }, [filteredTrades]);

    const columns = [
        columnHelper.display(expanderCol()),
        columnHelper.accessor('side', {
            ...baseCol({ id: 'side' }),
            cell: ({ getValue }) => <TradeSideTag side={getValue()} />,
        }),
        columnHelper.accessor('tradesCount', numberCol({ id: 'tradesCount', format: { fractionDigits: 0 } })),
        columnHelper.accessor('totalQuantity', numberCol({ id: 'totalQuantity', format: { fractionDigits: 0 } })),
        columnHelper.accessor('totalValue', moneyCol({ id: 'totalValue' })),
        columnHelper.display(excludeTradesCol(excludeTrades)),
    ];

    return (
        <TradesTable
            data={data}
            secondaryGrouping={secondaryGrouping}
            columns={columns}
            excludeTrades={excludeTrades}
            viewAsset={viewAsset}
            viewPortfolio={viewPortfolio}
            viewTrade={viewTrade}
            viewAdvanced={viewAdvanced}
        />
    );
};
